import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import * as DASHBOARD_ACTIONS from 'hooks/useDashboard/actions';
import useFetchDashboardMasterObject from 'hooks/useFetchDashboardMasterObject';
import TimeSeriesSetIdSelector from 'components/Widget/components/menus/MainSettings/components/TimeSeriesSetIdSelector';
import { makeStyles } from '@material-ui/core';
import { generateEmptyRecord } from '../content';
import BenchmarkSection from '../widget-steps/components/BenchmarkSection';
import MasterObjectSection from '../widget-steps/components/MasterObjectSection';
import StepControls from '../components/StepControls';

const useStyles = makeStyles({
  heading: {
    marginBottom: '10px',
    marginTop: '0',
    opacity: '0.7'
  }
});

const DefaultConfigurationStep = ({ setActiveStep, dispatchDashboard, dashboardData }) => {
  const { benchmarks, masterObjectTypeId, masterObjectTimeSeriesSetId } = dashboardData;
  const [
    masterObjectTypeIdLookupState,
    masterObjects,
    dispatchMasterObject
  ] = useFetchDashboardMasterObject({
    masterObjectTypeId: masterObjectTypeId || 1
  });
  const { isLoading } = masterObjectTypeIdLookupState;
  const classes = useStyles();
  const handleTimeSeriesSetSelect = id => {
    dispatchDashboard({
      type: DASHBOARD_ACTIONS.UPDATED_DASHBOARD,
      payload: {
        timeSeriesSetId: id
      }
    });
  };

  useEffect(() => {
    if (masterObjectTimeSeriesSetId) {
      handleTimeSeriesSetSelect(masterObjectTimeSeriesSetId);
    }
  }, [masterObjectTimeSeriesSetId]);

  useMemo(
    () =>
      dispatchDashboard({
        type: DASHBOARD_ACTIONS.UPDATED_DASHBOARD,
        payload: {
          benchmarks: generateEmptyRecord(benchmarks),
          masterObjectTypeId: masterObjectTypeId || 1
        }
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const handleNextStep = () => {
    setActiveStep(prev => prev + 1);
  };

  const handleBack = () => setActiveStep(prev => prev - 1);

  return (
    <>
      <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={2}>
        <MasterObjectSection
          dispatchUpdate={dispatchDashboard}
          updateAction={DASHBOARD_ACTIONS.UPDATED_DASHBOARD}
          objectState={dashboardData}
          masterObjectTypeIdLookupState={masterObjectTypeIdLookupState}
          masterObjects={masterObjects}
          dispatchMasterObject={dispatchMasterObject}
        />
        <Box width="100%" my={3} mx={1}>
          <Divider style={{ width: '100%' }} />
        </Box>
        <Grid item xs={12} md={6}>
          <h3 className={classes.heading}>Peer Group</h3>
          <TimeSeriesSetIdSelector
            handleSelect={handleTimeSeriesSetSelect}
            timeSeriesSetId={dashboardData.timeSeriesSetId}
            dashboardData={dashboardData}
          />
        </Grid>
        <Box width="100%" my={3} mx={1}>
          <Divider style={{ width: '100%' }} />
        </Box>
        {benchmarks && benchmarks.length && (
          <BenchmarkSection
            objectState={dashboardData}
            dispatchUpdate={dispatchDashboard}
            isLoading={isLoading}
            actions={DASHBOARD_ACTIONS}
            isDashboard
          />
        )}
      </Grid>
      <StepControls handleBack={handleBack} handleNext={handleNextStep} />
    </>
  );
};

DefaultConfigurationStep.propTypes = {
  dashboardData: PropTypes.shape({
    masterObjectId: PropTypes.number,
    masterObjectTypeId: PropTypes.number,
    benchmarks: PropTypes.arrayOf(),
    timeSeriesSetId: PropTypes.number
  }),
  dispatchDashboard: PropTypes.func.isRequired,
  setActiveStep: PropTypes.func.isRequired
};

DefaultConfigurationStep.defaultProps = {
  dashboardData: {}
};
export default DefaultConfigurationStep;
